import React from "react";

export const TimeDashboardSvg = React.forwardRef((props, svgRef) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    ref={svgRef}
    {...props}
  >
    <path
      fill="#FF9C9C"
      d="M70 40a30 30 0 0 1-58.432 9.57l8.522-2.868A21.008 21.008 0 0 0 61.008 40H70Z"
    />
    <path
      fill="#A0CBFD"
      d="M40 10a30 30 0 0 1 9.57 58.432l-2.868-8.522A21.009 21.009 0 0 0 40 18.992V10Z"
    />
    <path
      fill="#FBBB75"
      d="M25 65.98a30 30 0 0 1-14.939-24.063l8.974-.575a21.008 21.008 0 0 0 10.46 16.852L25 65.98Z"
    />
    <path
      fill="#C3E799"
      d="M11.022 47.764a30 30 0 0 1 6.453-27.579l6.751 5.94a21.01 21.01 0 0 0-4.518 19.312l-8.686 2.328Z"
    />
    <path
      fill="#B9E4E0"
      d="M14.02 25a30 30 0 0 1 24.063-14.939l.575 8.974a21.007 21.007 0 0 0-16.852 10.46L14.02 25Z"
    />
    <path
      fill="#FBD6E7"
      d="M32.236 11.022a29.996 29.996 0 0 1 8.12-1.02l-.106 8.991a21.01 21.01 0 0 0-5.687.715l-2.328-8.686Z"
    />
  </svg>
));
TimeDashboardSvg.displayName = "TimeDashboardSvg";
export default TimeDashboardSvg;
